export default "__VITE_ASSET__DqtGOgnA__"